/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-15 16:18:32
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-25 13:45:04
 */

export default {
  path: "position",
  component: () =>
    import(/* webpackChunkName: "position-list" */ "@/pages/position/List"),
  meta: { title: "岗位发布", cate: "操作中心" },
  children: [
    {
      path: "signup",
      component: () =>
        import(
          /* webpackChunkName: "position-list" */ "@/pages/position/Signup"
        ),
      meta: { title: "报名列表" },
      hidden: true,
    },
    {
      path: "create",
      component: () =>
        import(
          /* webpackChunkName: "position-list" */ "@/pages/position/CreateEdit"
        ),
      meta: { title: "发布岗位" },
      hidden: true,
    },
	{
	path: "registrationList",
	component: () =>
	import(
	/* webpackChunkName: "position-list" */ "@/pages/position/registrationList/index"
	),
	meta: { title: "报名审核" },
	hidden: true,
	},
  ],
};
